import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { Key } from 'antd/es/table/interface';
import LoadMoreSummary from '../../LoadMoreSummary';
import { Model } from '@/core/domain/people/BrandsModelsVersions/BrandsModelsVersions.types';
import { getTableScrollX } from '@/utils/table';

interface Props {
  isFetching: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  columns: ColumnsType<Model>;
  models: Model[];
  selectedBrandsModelsKeys: Key[];
  handleBrandsModelsSelect: (values: Key[]) => void;
  noSelection?: boolean;
}

const BrandsModelsTableModal: React.FC<Props> = ({
  isFetching,
  hasNextPage,
  fetchNextPage,
  columns,
  models,
  selectedBrandsModelsKeys,
  handleBrandsModelsSelect,
  noSelection,
}) => {
  return (
    <Table<Model>
      columns={columns}
      dataSource={models}
      loading={isFetching}
      className="scroll-table"
      rowKey={(row) => row.id}
      scroll={{ x: getTableScrollX(columns) }}
      pagination={false}
      summary={() =>
        hasNextPage ? (
          <LoadMoreSummary
            onClick={fetchNextPage}
            columnsCount={columns.length + 1}
          />
        ) : null
      }
      rowSelection={
        !noSelection
          ? {
              selectedRowKeys: selectedBrandsModelsKeys,
              onChange: handleBrandsModelsSelect,
            }
          : undefined
      }
    />
  );
};

export default BrandsModelsTableModal;
